import { CapoPlugin } from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];